import { render, staticRenderFns } from "./tenant_config_erm.vue?vue&type=template&id=8186f8f2&"
import script from "./tenant_config_erm.vue?vue&type=script&lang=js&"
export * from "./tenant_config_erm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports